// Mock data for SaraPrivéAviation website

export const companyInfo = {
  name: "SaraPrivéAviation",
  nameArabic: "سارا بريفيه للطيران",
  tagline: "Elite Cabin Crew Recruitment",
  subtitle: "Royal Elegance • Luxury • Discretion • Excellence",
  email: "sarapriveaviation@gmail.com",
  instagram: "sarapriveaviation",
  instagramUrl: "https://instagram.com/sarapriveaviation"
};

export const aboutUs = {
  title: "About Us",
  description: "Sara Privé Aviation is an exclusive recruitment agency specializing in VVIP and corporate cabin crew for private and commercial aviation.",
  mission: "Our mission: To redefine luxury aviation recruitment by combining European sophistication with Middle East hospitality standards.",
  values: "Founded on principles of elegance, discretion, and excellence, we connect prestigious clients with highly trained professionals. Every selection reflects class, professionalism and confidentiality."
};

export const whyChooseUs = [
  {
    id: 1,
    title: "Global Network",
    description: "Global network of elite professionals"
  },
  {
    id: 2,
    title: "Discreet Process",
    description: "Discreet and confidential recruitment process"
  },
  {
    id: 3,
    title: "Tailored Selection",
    description: "Tailored selection to client standards"
  },
  {
    id: 4,
    title: "Multilingual Candidates",
    description: "Multilingual and culturally aware candidates"
  }
];

export const candidateProfile = [
  {
    id: 1,
    title: "Exceptional Presentation",
    description: "Outstanding presentation and grooming standards"
  },
  {
    id: 2,
    title: "Service Background",
    description: "Experience in aviation, hospitality, or luxury sector"
  },
  {
    id: 3,
    title: "Professional Discretion",
    description: "Professional discretion and adaptability"
  }
];

export const locations = {
  title: "Operating Globally",
  focus: "With a focus on Europe & Middle East",
  regions: ["Europe", "Middle East"]
};

export const jobVacancies = [
  {
    id: 1,
    title: "VVIP Flight Attendant",
    location: "Riyadh",
    type: "Full-time",
    rotation: "2 months on 1 month off",
    description: "This is a full-time role for a VVIP Flight Attendant located in Riyadh. The Flight Attendant will be responsible for ensuring passenger safety, comfort, and overall satisfaction during flights.",
    qualifications: [
      "Excellent Communication and Customer Service skills",
      "Ability to work in a high-pressure environment and handle emergencies calmly",
      "Fluent in English (no Arabic Speaker)",
      "High School Diploma",
      "Neat and professional - no visible tattoos or piercings when in uniform"
    ]
  }
];

export const heroImage = "https://images.unsplash.com/photo-1625513123245-fcb02d69ad12?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHxwcml2YXRlJTIwamV0JTIwaW50ZXJpb3J8ZW58MHx8fHwxNzY0MzUwNjY3fDA&ixlib=rb-4.1.0&q=85";
